import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { BellIcon, SaveIcon, CheckCircleIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { MOCK_NOTIFICATION_TEMPLATES } from '../../lib/mockData';
import type { NotificationTemplate } from '../../lib/types';
export function NotificationsPage() {
  const [templates, setTemplates] = useState<NotificationTemplate[]>([...MOCK_NOTIFICATION_TEMPLATES]);
  const [saved, setSaved] = useState(false);
  const toggleActive = (id: string) => {
    setTemplates(prev => prev.map(t => t.id === id ? {
      ...t,
      isActive: !t.isActive
    } : t));
  };
  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  return <div data-id="element-827">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-828">
        <h1 className="text-2xl font-bold text-white mb-1 flex items-center gap-3" data-id="element-829">
          <BellIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-830" />
          Thông Báo
        </h1>
        <p className="text-sm text-[#666666] mb-6" data-id="element-831">
          Cấu hình mẫu thông báo cho các sự kiện
        </p>
      </motion.div>

      {saved && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-4 bg-[#22C55E]/10 border border-[#22C55E]/20 rounded-xl p-3 flex items-center gap-2" data-id="element-832">
          <CheckCircleIcon className="w-4 h-4 text-[#22C55E]" data-id="element-833" />
          <span className="text-sm text-[#22C55E]" data-id="element-834">Đã lưu!</span>
        </motion.div>}

      <div className="space-y-4" data-id="element-835">
        {templates.map((tmpl, i) => <motion.div key={tmpl.id} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} data-id="element-836">
            <Card data-id="element-837">
              <div className="flex items-start justify-between mb-3" data-id="element-838">
                <div data-id="element-839">
                  <h3 className="font-semibold text-white" data-id="element-840">{tmpl.eventVi}</h3>
                  <p className="text-xs text-[#666666]" data-id="element-841">{tmpl.event}</p>
                </div>
                <button onClick={() => toggleActive(tmpl.id)} className={`w-10 h-6 rounded-full transition-colors ${tmpl.isActive ? 'bg-[#C8A84E]' : 'bg-[#2A2A2A]'}`} data-id="element-842">
                  <div className={`w-5 h-5 bg-white rounded-full mt-0.5 transition-transform ${tmpl.isActive ? 'ml-[18px]' : 'ml-0.5'}`} data-id="element-843" />
                </button>
              </div>
              <div className="space-y-2" data-id="element-844">
                <div className="bg-[#141414] rounded-lg p-3" data-id="element-845">
                  <div className="flex items-center gap-2 mb-1" data-id="element-846">
                    <Badge size="sm" variant="info" data-id="element-847">
                      SMS
                    </Badge>
                  </div>
                  <p className="text-sm text-[#B0B0B0]" data-id="element-848">{tmpl.smsTemplate}</p>
                </div>
                <div className="flex gap-2" data-id="element-849">
                  <Badge size="sm" variant={tmpl.isActive ? 'success' : 'default'} data-id="element-850">
                    {tmpl.isActive ? 'Đang bật' : 'Đã tắt'}
                  </Badge>
                  <Badge size="sm" data-id="element-851">SMS</Badge>
                  <Badge size="sm" data-id="element-852">Zalo OA</Badge>
                </div>
              </div>
            </Card>
          </motion.div>)}
      </div>

      <div className="mt-6 flex justify-end" data-id="element-853">
        <Button onClick={handleSave} data-id="element-854">
          <SaveIcon className="w-4 h-4" data-id="element-855" />
          Lưu Cài Đặt
        </Button>
      </div>
    </div>;
}